import React from "react";
import Contact from "../contact/Contact";
import EmojiWrapper from "../layout/EmojiWrapper";

const About: React.FC = () => {
  return (
    <div className="about">
      <div className="flex about-container">
        <img src="/img/TimGolovinov.jpg" alt="Tim Golovinov Protrait" />
        <div className="about-text">
          <div>
            <h1>
              Hello, internet surfer <EmojiWrapper>🏄</EmojiWrapper>
            </h1>
            <p>
              As a tech entrepreneur, content creator, and software developer
              hailing from the southern regions of Russia, I now call Perth,
              Western Australia home. In my free time, I can be found working on
              my neurotech project, producing media, or hitting the waves for
              some surfing.
            </p>
            <p>
              Currently, my main area of interest now is brain-computer
              interfaces and related technology mainly in medtech and wellness
              sector. I finished a Master's research about neurotechnology,
              specifically Brain-Computer Interfaces (BCI) and now exploring
              practical commercialisable applications of BCIs, while working as
              a software engineer. In addition, I am fascinated about the AI,
              its rapid growth and those breakthrough AI products that bring
              real value and solve real problems. My passions in life include
              art, nature, and innovations, and I am constantly inspired by how
              they are shaping the world around us and changing our daily
              routines and behavior.
            </p>
            <p>
              By combining my business acumen, creative approach, and wealth of
              experience, I am able to bring a unique perspective to the table
              and deliver solutions that not only solve problems, but also
              provide a polished and aesthetically pleasing experience for all
              who interact with them.
            </p>
          </div>
          <Contact />
        </div>
      </div>
    </div>
  );
};

export default About;
